import {
  AnalyticsClientProvider,
  FeatureFlag,
  PortalAppContextConfig,
} from '@tangocard/portal-app-context'
import { version as applicationVersion } from '../package.json'
import localFeatures from '../local-features.json'

export default {
  applicationName: 'TangoPortal',
  applicationVersion,
  environment: import.meta.env.VITE_ENV_NAME,
  authentication: {
    baseUrl: import.meta.env.VITE_PORTAL_API_BASE_URL,
    loginCallbackUrl: import.meta.env.VITE_AUTH0_CALLBACK_URL,
  },
  apiClient: {
    baseUrl: import.meta.env.VITE_PORTAL_API_BASE_URL,
  },
  featureFlags: {
    apiKey: import.meta.env.VITE_SPLIT_IO_API_KEY,
    localFeatures,
  },
  chatbot: {
    dataHandle: import.meta.env.VITE_ADA_CHATBOT_DATA_HANDLE,
  },
  cookieConsent: (featureFlagClient) => {
    // Check for cookie consent configurations
    const trustArcDomain = import.meta.env.VITE_TRUSTARC_DOMAIN
    const oneTrustScriptId = import.meta.env.VITE_APP_ONE_TRUST_SCRIPT_ID

    // Get the feature flag value using the provided client
    const isTrustArc = featureFlagClient.isFeatureFlagEnabled(
      FeatureFlag.TrustArc,
    )

    const config: Record<string, unknown> = isTrustArc
      ? {
          provider: 'TrustArc',
          trustarc: { domain: trustArcDomain },
        }
      : {
          provider: 'OneTrust',
          apiKey: oneTrustScriptId,
          onetrust: { scriptId: oneTrustScriptId },
        }

    return Object.keys(config).length > 0 ? config : undefined
  },
  analytics: (featureFlagClient) => {
    if (!featureFlagClient.isFeatureFlagEnabled(FeatureFlag.SegmentEnabled)) {
      return undefined
    }

    return {
      apiKey: import.meta.env.VITE_SEGMENT_WRITE_KEY,
      provider: AnalyticsClientProvider.Segment,
      useCdn: true,
    }
  },
  datadome: {
    apiKey: import.meta.env.VITE_DATADOME_JS_KEY,
    config: {
      ajaxListenerPath: [import.meta.env.VITE_PORTAL_API_BASE_URL],
      sessionByHeader: true,
      withCredentials: false,
    },
  },
} as PortalAppContextConfig
